import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CrowdFlowAlert } from '../../model/crowd-flow-alert';

export interface CrowdFlowAlertsState extends EntityState<CrowdFlowAlert> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'CrowdFlowAlerts' })
export class CrowdFlowAlertsStore extends EntityStore<CrowdFlowAlertsState> {

  constructor() {
    super();
  }

}
